<template lang="pug">
	div
		#sfc-main-container.sfc-container-redesign-v1
			sfc-sentry
			sfc-hello-bar-v3
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-login
			sfc-forgot-password
			sfc-enroll-now-urgency-widget(:inPage="false")
			sfc-menu
			sfc-menu-mobile
			sfc-onboarding-modal-v2
			sfc-header(v-if="!isFinancialAidCalculatorForPortals()")
			#sfc-main-content
				b-container(:class="containerClass")
					b-row
						b-col(cols="12")
							nuxt
							no-ssr(v-if="!userSubscribed() && !isFinancialAidCalculatorForPortals()")
								b-row#bottom-ad
									.col-md-12.col-sm-12.col-xs-12.ad-align-center
										.bottom-banner(style="")
											sfc-dfp-ad(ad-unit="savingforcollege_other_bottom_leaderboard" sizes="[[600,230], [728,90]]")
			sfc-footer
			no-ssr
				sfc-gdpr-banner
		no-ssr
			sfc-college-savings-questions-modal
</template>

<style lang="stylus">
	//@import '~assets/css/redesign-v1/common.styl'
</style>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	.container-fluid
		padding: 0
		> .row
			margin: 0
			> .col
				padding: 0
</style>

<script>
import SfcHeader from '@/layouts/common/sfc-header-slim'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcEnrollNowUrgencyWidget from '@/common/components/redesign-v1/sfc-enroll-now-urgency-widget'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'

export default {
	components: {
		SfcHeader,
		SfcFooter,
		sfcCollegeSavingsQuestionsModal,
		SfcHelloBarV3,
		SfcEnrollNowUrgencyWidget,
		SfcMenu,
		SfcMenuMobile,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2
	},
	computed: {
		containerClass: function (){
			let isSfcFinancialAidCalculator = this.$route.path.indexOf('/financial-aid-calculator') >= 0 && this.$route.path.indexOf('/financial-aid-calculator-portals') < 0
			return isSfcFinancialAidCalculator ? 'container' : 'container-fluid'
		}
	},

	methods: {
		isFinancialAidCalculatorForPortals(){
			return this.$route.path.indexOf('/financial-aid-calculator-portals') >= 0
		},
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}
	}
}
</script>
